var map = {};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	return map[req] || (function() { throw new Error("Cannot find module '" + req + "'.") }());
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 2266;



//////////////////
// WEBPACK FOOTER
// ./~/caniuse-db/region-usage-json ^\.\/.*\.json$
// module id = 2266
// module chunks = 0